import React from 'react';
import PropTypes from 'prop-types';
import { Box, TextField } from '@mui/material';
import ConfigCard from './ConfigCard';

/**
 * "Contact information" card. Backed by the storefront's `SF_INFO_*`
 * settings — these populate the footer and the order-confirmation emails.
 *
 * value shape:
 *   { shopName, addressLine, city, vatNumber, phone, email, website }
 *
 * Field ↔ legacy key mapping (resolved by the WebshopConfigScreen save flow):
 *   shopName    ↔ SF_INFO_NAME
 *   addressLine ↔ SF_INFO_ADDRESS
 *   city        ↔ SF_INFO_CITY    (also typically holds postcode + country)
 *   vatNumber   ↔ SF_INFO_VAT
 *   phone       ↔ SF_INFO_PHONE
 *   email       ↔ SF_INFO_EMAIL
 *   website     ↔ SF_INFO_WEBSITE
 */
const ContactInformationCard = ({ value = {}, onChange, theme, t }) => {
    const tr = (key, fallback) => (typeof t === 'function' ? t(key) : fallback);
    const get = (k, fb = '') => (value[k] !== undefined ? value[k] : fb);
    const set = (k) => (e) => onChange && onChange(k, e.target.value);

    return (
        <ConfigCard
            title={tr('cfg_footer_contact_title', 'Contact information')}
            description={tr('cfg_footer_contact_desc', 'Shown at the bottom of every page.')}
            theme={theme}
        >
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 2 }}>
                <TextField size="small" label={tr('cfg_footer_contact_shop_name', 'Shop name')} value={get('shopName')}    onChange={set('shopName')}    sx={{ gridColumn: { sm: '1 / -1' } }} />
                <TextField size="small" label={tr('cfg_footer_contact_address',   'Address')}   value={get('addressLine')} onChange={set('addressLine')} sx={{ gridColumn: { sm: '1 / -1' } }} />
                <TextField size="small" label={tr('cfg_footer_contact_city',      'City')}      value={get('city')}        onChange={set('city')} />
                <TextField size="small" label={tr('cfg_footer_contact_vat',       'VAT number')}value={get('vatNumber')}   onChange={set('vatNumber')} />
                <TextField size="small" label={tr('cfg_footer_contact_phone',     'Phone')}     value={get('phone')}       onChange={set('phone')} />
                <TextField size="small" label={tr('cfg_footer_contact_email',     'Email')}     type="email" value={get('email')} onChange={set('email')} />
                <TextField size="small" label={tr('cfg_footer_contact_website',   'Website')}   value={get('website')}     onChange={set('website')} sx={{ gridColumn: { sm: '1 / -1' } }} />
            </Box>
        </ConfigCard>
    );
};

ContactInformationCard.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default ContactInformationCard;
